import { Picture } from "../../../types";
import ImageUpload from "./ImageUpload";

const DashboardImageSection = ({
  data,
  imageAmount,
  sectionId,
  onMovePictureUp,
  onMovePictureDown,
  onAddPicture,
  onRemoveImage,
  onUpdatePicture,
}: {
  data: Picture[];
  imageAmount: number;
  sectionId: number;
  onMovePictureUp: (sectionId: number, pictureId: number) => void;
  onMovePictureDown: (sectionId: number, pictureId: number) => void;
  onAddPicture: (sectionId: number) => void;
  onRemoveImage: (sectionId: number, pictureId: number) => void;
  onUpdatePicture: (
    sectionId: number,
    pictureId: number,
    dataUrl: string
  ) => void;
}) => {
  const hasReachedMaxImages = data.length < imageAmount || imageAmount === -1;

  return (
    <div style={{ border: "1px solid white", display: "flex" }}>
      {hasReachedMaxImages && (
        <div>
          <button
            style={{ height: "100%" }}
            onClick={() => onAddPicture(sectionId)}
          >
            Bild hinzufügen
          </button>
        </div>
      )}
      {data.map((picture) => (
        <div key={picture.id} style={{ border: "1px solid white" }}>
          <h3>Bild-Id {picture.id}</h3>
          <button onClick={() => onMovePictureUp(sectionId, picture.id)}>
            Nach Links
          </button>
          <button onClick={() => onMovePictureDown(sectionId, picture.id)}>
            Nach Rechts
          </button>
          <ImageUpload
            onRemoveImage={() => onRemoveImage(sectionId, picture.id)}
            image={picture.dataUrl}
            onImageUpload={(v) => onUpdatePicture(sectionId, picture.id, v)}
          />
        </div>
      ))}
    </div>
  );
};
export default DashboardImageSection;
